import styles from "./ProfileTable.module.css";

const ProfileTable = ({ name, username, displayName, email }) => {
    return (
        <table className={styles.ProfileTable} data-testid="profile-table">
            <tbody>
                <tr>
                    <td>
                        <div>Name</div>
                    </td>
                    <td>{name}</td>
                </tr>
                <tr>
                    <td>
                        <div>Username</div>
                    </td>
                    <td>{username}</td>
                </tr>
                <tr>
                    <td>
                        <div>Display Name</div>
                    </td>
                    <td>{displayName}</td>
                </tr>
                <tr>
                    <td>
                        <div>Email</div>
                    </td>
                    <td>{email}</td>
                </tr>
            </tbody>
        </table>
    );
};

export default ProfileTable;
